import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { couponCodeAtom, productKeyAtom } from "src/atoms";
import { useGetPriceList } from "src/hooks/api/pay/useGetPriceList";
import { getProductFromSessionStorage } from "src/utils/storage/auth";

interface IPriceCheckerProps {
  currency: string; // 원화 정보
  setUserPerPrice: React.Dispatch<React.SetStateAction<number>>; // 사용자당 월 요금
  setUserPerPriceYear: React.Dispatch<React.SetStateAction<number>>; // 사용자당 연 요금
  setPriceType: React.Dispatch<React.SetStateAction<string>>; // 요금제

  // PAYPAL 결제시 사용
  setPlanId: React.Dispatch<React.SetStateAction<string>>;
  setPriceUid: React.Dispatch<React.SetStateAction<string>>;
}
// 현재 요금제 가격 정보 세팅
const PriceChecker = ({
  currency,
  setUserPerPrice,
  setUserPerPriceYear,
  setPriceType,
  setPlanId,
  setPriceUid,
}: IPriceCheckerProps) => {
  const { watch, setValue } = useFormContext();
  const [params] = useSearchParams();
  const [productKey] = useRecoilState(productKeyAtom);
  const [couponCodeInfo] = useRecoilState(couponCodeAtom);
  const { priceList } = useGetPriceList({
    product: getProductFromSessionStorage(),
  }); // 제품별 요금제 정보
  const licenseCount = watch("licenseCount");
  const payTerm = watch("payTerm");
  const calcPrice = (unitPrice: number) => {
    let basePrice = Math.floor(unitPrice * licenseCount);
    basePrice = Math.floor(basePrice * 1.1); // 부가세 추가

    if (couponCodeInfo) {
      if (couponCodeInfo.discountType === "PERCENT") {
        basePrice = basePrice * (1 - couponCodeInfo.discountPrice / 100);
      } else {
        basePrice = basePrice - couponCodeInfo.discountPrice;
      }
    }
    // 최종적으로 소수점 제거
    if (basePrice < 0) return 0;
    else return Math.floor(basePrice);
  };
  useEffect(() => {
    if (currency && priceList && payTerm && params && licenseCount) {
      priceList.find((price) => {
        if (
          price.priceType === params.get("type") &&
          price.product === productKey &&
          price.currency === currency
        ) {
          setPriceType(price.priceType);
          setUserPerPrice(price.userPerPrice);
          setUserPerPriceYear(price.userPerPriceYear);
          if (payTerm === "month") {
            if (price?.planIdMonth) {
              setPlanId(price.planIdMonth);
            }
            setValue("totalPrice", calcPrice(price.userPerPrice));
          } else if (payTerm === "year") {
            if (price?.planIdYear) {
              setPlanId(price.planIdYear);
            }
            setValue("totalPrice", calcPrice(price.userPerPriceYear * 12));
          }
          if (price.priceUid) {
            setPriceUid(price.priceUid);
            setValue("priceUid", price.priceUid);
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payTerm, params, currency, priceList, licenseCount, couponCodeInfo]);
  return null;
};

export default PriceChecker;
